export default (($) => {
    console.log('UNTUCKit : Module : Sidebar : loaded');
    const buildClicked = function ($el, clicked) {
        const $parent = $el.parent().parent().prev('a');
        clicked = typeof clicked === 'undefined' ? $el.text() : clicked;
        if ($parent.length) {
            const newText = $parent.text();
            clicked = buildClicked($parent, newText + ' > ' + clicked);
        }
        return clicked;
    };
    const bindUIActions = function () {
        $('.collection_sidenav a').on('click', function () {
            const $this = $(this), clicked = 'Side Nav > ' + buildClicked($this), navPosition = 'top';
            window.dataLayer.push({
                event: 'Nav Click',
                itemClicked: clicked,
                navPosition: navPosition,
            });
        });
    };
    function init() {
        console.log('UNTUCKit : Module : Sidebar : init');
        bindUIActions();
    }
    return { init };
})($);
